import { useDispatch } from 'react-redux';

const useCustomDispatch = () => {

    return useDispatch();
};

export default useCustomDispatch;
